import { createSlice } from "@reduxjs/toolkit";

interface MemberState {}

const initialState: MemberState = {};

export const memberSlide = createSlice({
  initialState,
  name: "member",
  reducers: {},
});

export const {} = memberSlide.actions;

export default memberSlide.reducer;
